<style>
.add-owner {
    float: right;
}

.ranges {
    max-height: 200px;
    overflow: scroll;
}

.alert-primary {
    width: 100%;
}
</style>

<template>
  <div>

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>

        <b-row v-if="role.id == 5">
          <b-col cols="4">
            <b-form-group
              labe-for="region_id"
              label="Region"
            >
              <validation-provider
                #default="{ errors }"
                name="Region"
                rules=""
              >
                <b-form-select
                  id="region_id"
                  v-model="filter.region_id"
                  name="region_id"
                  size="sm"
                  @change="changeRegion(filter.region_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="location in locations"
                    :key="location.id"
                    :value="location"
                  >
                    {{ location.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.region_id"
                  class="text-danger"
                >{{
                  serverErrors.region_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group
              labe-for="location_id"
              label="Area"
            >
              <validation-provider
                #default="{ errors }"
                name="Area"
                rules=""
              >
                <b-form-select
                  id="location_id"
                  v-model="filter.location_id"
                  name="location_id"
                  size="sm"
                  @change="getAreaMarket(filter.location_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="location in locId.children"
                    :key="location.id"
                    :value="location.id"
                  >
                    {{ location.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.location_id"
                  class="text-danger"
                >{{
                  serverErrors.location_id[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>

          <b-col cols="4">
            <b-form-group
              labe-for="market_id"
              label="Market Center"
            >
              <validation-provider
                #default="{ errors }"
                name="Market Center"
                rules=""
              >
                <b-form-select
                  id="market_id"
                  v-model="filter.market_id"
                  name="market_id"
                  size="sm"
                  @change="getAreaMarketSale(filter.market_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="market in markets"
                    :key="market.id"
                    :value="market.id"
                  >
                    {{ market.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.market_id"
                  class="text-danger"
                >{{
                  serverErrors.market_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="4">
            <b-form-group
              labe-for="sale_id"
              label="Sale"
            >
              <validation-provider
                #default="{ errors }"
                name="Sale"
                rules=""
              >
                <b-form-select
                  id="sale_id"
                  v-model="filter.sale"
                  name="sale_id"
                  size="sm"
                  @change="changeSale($event)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="sale in sales"
                    :key="sale.id"
                    :value="sale"
                  >
                    {{ sale.number }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.sale_id"
                  class="text-danger"
                >{{
                  serverErrors.sale_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

        </b-row>

        <b-row v-if="role.id != 5">
          <b-col
            v-if="locId.id > 0"
            cols="4"
          >
            <b-form-group
              labe-for="location_id"
              label="Area"
            >
              <validation-provider
                #default="{ errors }"
                name="Area"
                rules=""
              >
                <b-form-select
                  id="location_id"
                  v-model="filter.location_id"
                  name="location_id"
                  size="md"
                  @change="getAreaMarket(filter.location_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="location in locId.children"
                    :key="location.id"
                    :value="location.id"
                  >
                    {{ location.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.location_id"
                  class="text-danger"
                >{{
                  serverErrors.location_id[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>
          <b-col
            v-if="locId.id > 0"
            cols="4"
          >
            <b-form-group
              labe-for="market_id"
              label="Market Center"
            >
              <validation-provider
                #default="{ errors }"
                name="Market Center"
                rules=""
              >
                <b-form-select
                  id="market_id"
                  v-model="filter.market_id"
                  name="market_id"
                  size="md"
                  @change="getAreaMarketSale(filter.market_id)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="market in markets"
                    :key="market.id"
                    :value="market.id"
                  >
                    {{ market.name.toUpperCase() }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.market_id"
                  class="text-danger"
                >{{
                  serverErrors.market_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="locId.id > 0"
            cols="4"
          >
            <b-form-group
              labe-for="sale_id"
              label="Sale"
            >
              <validation-provider
                #default="{ errors }"
                name="Sale"
                rules=""
              >
                <b-form-select
                  id="sale_id"
                  v-model="filter.sale"
                  name="sale_id"
                  size="md"
                  @change="changeSale($event)"
                >
                  <b-form-select-option :value="null">
                    Select...
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="sale in sales"
                    :key="sale.id"
                    :value="sale"
                  >
                    {{ sale.number }}
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.sale_id"
                  class="text-danger"
                >{{
                  serverErrors.sale_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="3" v-if="locId.id > 0">
                        <b-form-group labe-for="society_id" label="Society">
                            <validation-provider #default="{ errors }" name="Society" rules="">
                                <b-form-select id="society_id" name="society_id" size="md" v-model="filter.society_id"
                                    @change="changeSociet(filter.society_id)">
                                    <b-form-select-option :value="null">Select...</b-form-select-option>
                                    <b-form-select-option v-for="society in societies" :key="society.id"
                                        :value="society.id">
                                        {{ society.name }}
                                    </b-form-select-option>
                                </b-form-select>
                                <small class="text-danger">{{ errors[0] }}</small>
                                <small class="text-danger" v-if="serverErrors && serverErrors.society_id">{{
                                    serverErrors.society_id[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col> -->
        </b-row>

        <b-row>
          <!--
                    <pre>
                    {{ filter }}
                 </pre> -->

          <table
            class="table"
            style="margin-top: 20px"
          >
            <thead>
              <tr>
                <th scope="col">
                  SN
                </th>
                <th scope="col">
                  Society Name
                </th>
                <th scope="col">
                  Bales Bought
                </th>
                <th scope="col">
                  Mass Bought
                </th>
                <th scope="col">
                  Value
                </th>
                <th scope="col">
                  Date Closed
                </th>
                <th scope="col">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(society, index) in societies">
                <th scope="row">
                  {{ index + 1 }}
                </th>
                <td>{{ society.name }}</td>
                <td />
                <td />
                <td />
                <td>{{ society.closeDate }}</td>
                <td>
                  <b-button
                    variant="primary"
                    size="sm"
                    :disabled="society.closed"
                    @click="closeSale(society)"
                  >
                    <span class="text-nowrap">
                      <span v-if="society.closed">Closed</span>
                      <span v-if="!society.closed">Close Sale</span>
                    </span>
                  </b-button>

                  <b-button
                    v-if="society.closed"
                    variant="info"
                    class="ml-1"
                    size="sm"
                    @click=""
                  >
                    <span class="text-nowrap">Re Open</span>
                  </b-button>

                </td>
              </tr>

            </tbody>

          </table>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner, BFormCheckbox, BBadge, BAlert, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import {
    ref, onUnmounted, onMounted, reactive,
} from '@vue/composition-api'

import purchaseDataStoreModule from '@/views/cromis/sales/purchase_data/purchaseDataStoreModule'
import usepurchaseDataList from '@/views/cromis/sales/sale_close/useSaleCloseList'
import Panel from 'primevue/panel'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        BFormCheckbox,
        BBadge,
        BAlert,
        Panel,
        Accordion,
        AccordionTab,
        BFormDatepicker,
    },
    directives: {},
    props: {},
    watch: {
        userInput(newInput, oldInput) {
            // Update default value when user input changes
            if (!isNaN(newInput)) {
                this.defaultValue -= (newInput - oldInput)
            } else {
                // Handle case where userInput is NaN (e.g., after deleting the number)
                this.defaultValue = this.defaultValue
            }
        },
    },
    setup(props, context) {
        const dataForm = ref(null)
        const myModalPcn = ref(null)
        const myViewModal = ref(null)
        const myRangeModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const totalMass = ref(null)
        const totalValue = ref(null)
        const errosOcurs = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const levels = ref(null)
        const totalWeight = ref(0)
        const tValue = ref(0)
        const companies = ref([])
        const societies = ref([])
        const markets = ref([])
        const requisitionDetail = ref(null)
        const locations = ref([])
        const sales = ref([])
        const children = ref([])
        const tikets = ref([])
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today)
        const saleInfo = ref({})
        const filter = ref({
            region_id: null,
            location_id: null,
            market_id: null,
            sale: null,
            sale_id: null,
            society_id: null,
        })

        const locId = ref(JSON.parse(localStorage.getItem('userData')).location)
        const role = ref(JSON.parse(localStorage.getItem('userData')).roles[0])
        console.log(locId)

        const CROMIS_STORE_MODULE_NAME = 'cromis-sale_close'
        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, purchaseDataStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-sale_close/locations')
                .then(response => {
                    locations.value = response.data.locations

                    console.log(response)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const populateSelections = locations => {
            for (let i = 0; i < locations.length; i++) {
                for (let x = 0; x < selections.value.length; x++) {
                    if (locations[i].level.name.toLowerCase() === selections.value[x].level) {
                        selections.value[x].locations.push(locations[i])

                        if (x === 0) {
                            formSelections.value[x].locations.push(locations[i])
                        }
                    }
                }
            }
        }

        // Form Methods
        const viewPcn = item => {
            tikets.value = item

            for (let index = 0; index < tikets.value.length; index++) {
                console.log(tikets.value[index])
                totalWeight.value += parseFloat(tikets.value[index].mass)
                tValue.value += parseFloat(tikets.value[index].value)
            }

            myModalPcn.value.show()
        }

        const approveRequisition = item => {
            console.log(item)
            handleApprove(item)
        }

        const getTotalValue = valueArray => {
            console.log(valueArray)
            totalValue.value = 0
            for (let index = 0; index < valueArray.length; index++) {
                totalValue.value = valueArray[index].mass
            }
            // valueArray.forEach(ele => {
            //     totalValue.value += ele.value;
            // });

            return totalValue.value
        }

        const getTotalMass = massArray => {
            totalMass.value = 0
            // console.log(massArray)
            // massArray.forEach(ele => {
            //     totalMass.value += ele.mass;
            // });

            for (let index = 0; index < massArray.length; index++) {
                totalMass.value = massArray[index].value
            }

            return totalMass.value
        }

        const getPcn = async () => {
            console.log(filter.value)
            filter.value.sale_id = filter.value.sale_id.id
            const data = {
                society_id: filter.value.society_id,
                sale_id: filter.value.sale_id,
                print: true,
            }
            console.log(data)

            await store.dispatch('cromis-sale_close/create', data)
                .then(response => {
                    context.root.$swal({
                        icon: 'success',
                        text: 'Sales Document prints initialized!',
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    console.log(error)
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleCheckboxChange = async (event, id) => {
            console.log(event)
            const payload = {
                sale_closed: event,
            }

            await store.dispatch('cromis-sale_close/update', { id, data: payload })
                .then(response => {
                    console.log(response)
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to PCN has been saved successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const getAreaMarket = async () => {
            await store.dispatch('cromis-sale_close/markets', { location_id: filter.value.location_id })
                .then(response => {
                    markets.value = response.data.markets

                    console.log(response)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const getAreaMarketSale = async () => {
            await store.dispatch('cromis-sale_close/sales', { market_id: filter.value.market_id })
                .then(response => {
                    sales.value = response.data.sales
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const changeSociet = async id => {
            // societyFilter.value = id
            const data = {
                society_id: id,
                sale_id: filter.value.sale.id,
                print: false,
            }
            console.log(data)

            await store.dispatch('cromis-sale_close/create', data)
                .then(response => {
                    console.log(response)
                    saleInfo.value = response.data

                    console.log(saleInfo.value)
                })
                .catch(error => {
                    console.log(error)
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const changeSale = async event => {
            // societies.value = event.societies

            event.societies.forEach(soc => {
                if (!soc.closed) {
                    societies.value.push(soc)
                    console.log('1')
                }
            })

            console.log(societies.value)
            filter.value.sale_id = filter.value.sale.id
        }

        const closeSale = async event => {
            const saleData = {
                sale_id: filter.value.sale_id,
                society_id: event.id,
            }
            const result = context.root.$swal({
                icon: 'info',
                title: 'System Info',
                text: 'Are you sure you want to Close Sale for this society?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, Close it!',
                cancelButtonText: 'No, cancel',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-danger ml-2', // Optional: Customize the cancel button class
                },
                buttonsStyling: true,
            }).then(result => {
                if (result.value) {
                    closeNow(saleData)
                } else {
                    context.root.$swal({
                        icon: 'info',
                        title: 'Cancelled',
                        text: 'Your Sale is safe you cancell close of it',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                }
            })
        }

        const closeNow = async data => {
            await store.dispatch('cromis-sale_close/create', data)
                .then(response => {
                    // console.log(response.data.data.societies)
                    societies.value = []
                    response.data.data.societies.forEach(soc => {
                        if (!soc.closed) {
                            societies.value.push(soc)
                            console.log('1')
                        }
                    })
                    context.root.$swal({
                        icon: 'success',
                        text: 'Sale for selected Society is closed successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        const changeRegion = async event => {
            locId.value = event
            console.log(locId.value)
            // filter.value.sale_id = event.id
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            handleCreate()
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
            }
        }

        const handleApprove = async item => {
            saving.value = true

            const data = {
                approved: true,
            }

            console.log(item)
            console.log(data)

            await store.dispatch('cromis-sale_close/update', { id: item.id, data })
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Approved has been made successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    errosOcurs.value = error.response.data
                    console.log(error.response)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors

                        console.log(serverErrors)
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-sale_close/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            // Data
            selections,
            formSelections,
            levels,
            children,

            selectedOwner: null,
            clientName: JSON.parse(localStorage.getItem('userData')).client,
            // Methods

            required,
            saving,
            serverErrors,
            dataForm,
            myModalPcn,
            myViewModal,
            requisitionDetail,
            filter,
            markets,
            locations,
            sales,
            changeSale,
            changeSociet,
            changeRegion,
            myRangeModal,

            viewPcn,
            approveRequisition,
            submit,
            isFormValid,
            handleCreate,
            companies,
            societies,
            errosOcurs,
            locId,
            role,
            getAreaMarket,
            getAreaMarketSale,
            handleApprove,
            minDate,
            getPcn,
            handleCheckboxChange,
            getTotalMass,
            getTotalValue,
            totalMass,
            totalValue,
            tikets,
            totalWeight,
            tValue,
            saleInfo,
            closeSale,
            closeNow,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
